
'use strict';
/**
 * @pbdoc Service
 * @name itemDataService
 * @packageName item_data_service
 *
 * @description
 *
 * The `itemDataService` service, managed itemDataService between seperated views
 *
 */
class itemDataService {

    constructor ($rootScope) {
        this.$rootScope = $rootScope;
        this.itemObj = {};

    }

    setItemObj(item) {
        this.itemObj = item;
    }

    getItemObj() {
        return this.itemObj;
    }

    subscribe(type, scope, callback) {
        var handler = this.$rootScope.$on('itemdata-service-data-change-'+type, callback);
        scope.$on('$destroy', handler);
    }

    notify(type) {
        this.$rootScope.$emit('itemdata-service-data-change-'+type);
    }

}

itemDataService.$inject= ['$rootScope'];

/*
 * Browsify connection: execute service
 * @Return {instance} A new instance of this directive
 */
module.exports = itemDataService;